import { useEffect } from "react";

export function useBFCacheListener(
  setCoverageCheckoutButtonClicked: React.Dispatch<
    React.SetStateAction<boolean>
  >,
) {
  // Add event listener for "back cached" navigation
  // defines logic that must happen on page load,
  // even when arriving from a back cache
  useEffect(() => {
    const func = (event: PageTransitionEvent) => {
      if (event.persisted) {
        // do something if page loaded from bfcache
        setCoverageCheckoutButtonClicked(false);
      }
    };
    window.addEventListener("pageshow", func);

    return () => {
      window.removeEventListener("pageshow", func);
    };
  }, [setCoverageCheckoutButtonClicked]);
}
